import { useQuery } from "react-query";

import { searchService } from "services";

type UseUnderwritingSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useUnderwritingSearchQuery = ({
	pattern,
	page,
	options,
}: UseUnderwritingSearchQueryProps) =>
	useQuery(
		["underwritingSearch", pattern, page],
		() =>
			searchService.getUnderwritings({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useUnderwritingSearchQuery;
